import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { IUserPartnersSubscriptions } from "@litres-libs/types";
import { addHydrateReducer } from "../../utils/hydrateReducer";

const initialState: IUserPartnersSubscriptions = {
  isAnyPartnerSubscriptionActive: false,
  isMegafonSubscriptionActive: false,
  isRostelecomSubscriptionActive: false,
  isYotaSubscriptionActive: false,
  isA1SubscriptionActive: false,
  isKCellSubscriptionActive: false,
  isInlabSubscriptionActive: false,
  isTinkoffSubscriptionActive: false,
  isLifebelSubscriptionActive: false,
};

export const partnersSubscriptionSlice = createSlice({
  name: "user/partnersSubscriptions",
  initialState,
  reducers: {
    setUserPartnersSubscriptions: (
      state: IUserPartnersSubscriptions,
      action: PayloadAction<IUserPartnersSubscriptions>
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
  extraReducers: builder => {
    addHydrateReducer(builder, "user.partnersSubscriptions");
  },
});

export const { setUserPartnersSubscriptions } =
  partnersSubscriptionSlice.actions;

export default partnersSubscriptionSlice.reducer;
